type UIType = {
    trigger: HTMLButtonElement;
    dialog: HTMLDialogElement;
    backdrop: HTMLDivElement;
    input: HTMLInputElement;
    copy: HTMLButtonElement;
    close: HTMLButtonElement;
}

export default (module: HTMLElement) => {
    const UI: UIType = {
        trigger: module.querySelector('[data-share-target="trigger"]') as HTMLButtonElement,
        dialog: module.querySelector('[data-share-target="dialog"') as HTMLDialogElement,
        backdrop: module.querySelector('[data-share-target="backdrop"]') as HTMLDivElement,
        input: module.querySelector('[data-share-target="input"]') as HTMLInputElement,
        copy: module.querySelector('[data-share-target="copy"]') as HTMLButtonElement,
        close: module.querySelector('[data-share-target="close"]') as HTMLButtonElement,
    }

    const openDialog = async () => {
        const shareData = JSON.parse(UI.trigger.dataset.share);
        if (navigator.canShare) {
            try {
                await navigator.share(shareData);
            } catch (err) {
                UI.dialog.showModal();
                document.body.classList.add('overflow-hidden');

                // Select all the text in the input field
                UI.input.select();
            }
        } else {
            UI.dialog.showModal();
            document.body.classList.add('overflow-hidden');

            // Select all the text in the input field
            UI.input.select();
        }
    }

    const closeDialog = () => {
        UI.dialog.close();
        document.body.classList.remove('overflow-hidden');
    }

    const handleCopy = () => {
        // Copy the text in the input field to the clipboard
        UI.input.select();
        document.execCommand('copy');

        // Close the dialog after copying
        closeDialog();
    }

    UI.trigger.addEventListener('click', openDialog);
    UI.backdrop.addEventListener('click', closeDialog);
    UI.copy.addEventListener('click', handleCopy);
    UI.close.addEventListener('click', closeDialog);
}